import { Box, Chip, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import type {
    SchoolsControllerGetSchoolLandingQueryParams
} from '@/global/api/gen/ts/schoolsDTO/SchoolsControllerGetSchoolLanding';
import { DriveEta as DriveIcon, LocationOn as LocationIcon } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import type { RegionDto } from '@/global/api/gen/ts/RegionDto';
import { AutoSchoolSearch } from './AutoSchoolSearch';
import { apiGetRegionList } from '@/modules/regions/services/regions.service';
import { AutoSchoolsList } from './AutoSchoolsList';

export function SchoolsCatalogMain() {
    const {cityId} = useParams<{ cityId: string }>();

    const {data: regions} = apiGetRegionList({
        limit: 100,
        offset: 0
    });

    const [selectedCity, setSelectedCity] = useState<RegionDto | null>(null);

    useEffect(() => {
        if (!regions) return;
        setSelectedCity(regions.items.find((region) => region.id === +(cityId ?? 0)) ?? null);
    }, [regions, cityId]);

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategories, setSelectedCategories] = useState<string[]>([]);

    const params: Omit<SchoolsControllerGetSchoolLandingQueryParams, 'offset' | 'limit'> = {
        q: searchQuery,
        categories: selectedCategories,
        region: selectedCity?.id ?? (cityId ? +(cityId) : undefined)
    };

    const handleClearFilters = () => {
        setSearchQuery('');
        setSelectedCategories([]);
        if (!cityId) {
            setSelectedCity(null);
        }
    };

    return (
        <>
            <Box sx={{mb: 4}}>
                <AutoSchoolSearch
                    searchQuery={searchQuery}
                    onSearchChange={setSearchQuery}
                    selectedCategories={selectedCategories}
                    selectedCity={selectedCity?.id}
                    onCityChange={cityId ? undefined : setSelectedCity}
                    onCategoriesChange={setSelectedCategories}
                    onClearFilters={handleClearFilters}
                />
            </Box>

            {((!cityId && selectedCity) || selectedCategories.length > 0) && (
                <Box sx={{mb: 3}}>
                    <Stack
                        direction="row"
                        spacing={1}
                        flexWrap="wrap"
                        gap={1}
                    >
                        {!cityId && selectedCity && (
                            <Chip
                                icon={<LocationIcon/>}
                                label={selectedCity.name_ru}
                                onDelete={() => setSelectedCity(null)}
                                color="primary"
                            />
                        )}
                        {selectedCategories.map(category => (
                            <Chip
                                key={category}
                                icon={<DriveIcon/>}
                                label={`Категория ${category}`}
                                onDelete={() => setSelectedCategories(prev => prev.filter(c => c !== category))}
                                color="secondary"
                            />
                        ))}
                    </Stack>
                </Box>
            )}

            <AutoSchoolsList params={params}/>
        </>
    );
}